// extracted by mini-css-extract-plugin
module.exports = {"nodataContainer":"NodataView_nodataContainer__L7pMJ"};